module.exports = __webpack_public_path__ + "img/croma.18df59c9.png";